<footer hide-sm="" class="footer"><a href="" class="footer-text">Powered by Psychometric</a></footer>
